import React from "react";
import DeferredVideo from './DeferredVideo';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Testimonials = ({ hideCta = false, compactTop = false }) => {
  const L = useLanguage();
  const location = useLocation();
  const isRegisterPage = location.pathname === '/register';

  const reviews = [
    {
      name: "Daniel",
      username: "daniel_slovak",
      platform: "instagram",
      link: "https://www.instagram.com/daniel_slovak/",
      image: "https://i.imgur.com/mQyhndN.jpeg",
      growth: "10k → 40k",
      stars: 5,
    },
    {
      name: "Smoke",
      username: "smoke",
      platform: "instagram",
      link: "https://www.instagram.com/smoke/",
      image: "https://i.imgur.com/kFw388B.jpeg",
      growth: "180k → 359k",
      stars: 5,
    },
    {
      name: "Vikky",
      username: "vikky",
      platform: "instagram",
      link: "https://www.instagram.com/vikky/",
      image: "https://i.imgur.com/bLEES7L.jpeg",
      growth: "800 → 2.5k",
      stars: 5,
    },
  ];

  const profiles = [
    { href: "https://instagram.com/gr.tomek", img: "https://i.imgur.com/7mB7Ssd.jpeg", name: "@gr.tomek", followers: "4k", growth: "+2.8k", verified: true },
    { href: "https://instagram.com/toyotasupra", img: "https://i.imgur.com/kVWy4sC.jpeg", name: "@toyotasupra", followers: "3.2k", growth: "+1.9k" },
    { href: "https://instagram.com/daniel_slovak", img: "https://i.imgur.com/mQyhndN.jpeg", name: "@daniel_slovak", followers: "40k", growth: "+30k" },
    { href: "https://instagram.com/vikky", img: "https://i.imgur.com/bLEES7L.jpeg", name: "@vikky", followers: "2.5k", growth: "+1.7k" },
  ];

  return (
    <>
      <section id="testimonials" style={{ paddingTop: compactTop ? '1rem' : '4rem', paddingBottom: '4rem', background: '#fff' }}>
        <div className="mx-auto px-4 stripe-container" style={{ maxWidth: '1100px' }}>

          {/* Section Header */}
          <div className="text-center" style={{ marginBottom: '3rem' }}>
            <h2
              className="stripe-heading stripe-heading--lg"
              style={{ maxWidth: '700px', margin: '0 auto', fontSize: compactTop ? 'clamp(1.8rem, 7vw, 2rem)' : undefined }}
            >
              {L.testimonials.heading}
            </h2>
            {!compactTop && (
              <p className="mt-3 mx-auto stripe-body stripe-body--md" style={{ maxWidth: '520px', color: '#64748b' }}>
                {L.testimonials.sub}
              </p>
            )}

            {!compactTop && (
              <div className="d-inline-flex align-items-center gap-2 mt-3 px-4 py-2" style={{ background: '#fafafa', borderRadius: '16px', border: '1px solid #f0f0f0' }}>
                <div className="d-flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} aria-hidden="true" style={{ color: '#facc15', fontSize: '0.85rem' }}>★</span>
                  ))}
                </div>
                <span style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0a2540' }}>4.9/5</span>
                <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>{L.testimonials.fromReviews}</span>
              </div>
            )}
          </div>

          {/* Review Cards */}
          <div className="row justify-content-center" style={{ gap: '0' }}>
            {reviews.map((review, index) => (
              <div key={index} className="col-12 col-md-4 mb-4">
                <div style={{
                  background: '#fff',
                  border: '1px solid #e8ecf1',
                  borderRadius: '16px',
                  padding: '2rem 1.75rem',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'box-shadow 0.3s ease, transform 0.3s ease',
                  cursor: 'default',
                }}
                onMouseOver={(e) => { e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseOut={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                  {/* Stars */}
                  <div className="d-flex gap-1 mb-3">
                    {[...Array(review.stars)].map((_, i) => (
                      <span key={i} aria-hidden="true" style={{ color: '#facc15', fontSize: '0.8rem' }}>★</span>
                    ))}
                  </div>

                  {/* Quote */}
                  <p style={{ fontSize: '0.95rem', lineHeight: 1.7, color: '#334155', flex: 1, margin: 0 }}>
                    "{L.testimonials.reviews[review.username]}"
                  </p>

                  {/* Divider */}
                  <div style={{ height: '1px', background: '#f1f5f9', margin: '1.25rem 0' }}></div>

                  {/* Author */}
                  <div className="d-flex align-items-center gap-3">
                    <a href={review.link} target="_blank" rel="noopener noreferrer">
                      <img
                        src={review.image}
                        alt={review.name}
                        style={{ width: '44px', height: '44px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #f1f5f9' }}
                      />
                    </a>
                    <div style={{ flex: 1 }}>
                      <div className="d-flex align-items-center gap-1">
                        <span style={{ fontWeight: 600, fontSize: '0.9rem', color: '#0a2540' }}>{review.name}</span>
                        <i className="fa-solid fa-circle-check" style={{ color: '#3b82f6', fontSize: '0.75rem' }}></i>
                      </div>
                      <a href={review.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', fontSize: '0.8rem', color: '#94a3b8' }}>
                        <i className="fab fa-instagram text-instagram" style={{ fontSize: '0.75rem', marginRight: '3px' }}></i>
                        @{review.username}
                      </a>
                    </div>
                    <div className="text-end">
                      <div style={{ fontSize: '0.7rem', color: '#94a3b8', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{L.testimonials.growthLabel}</div>
                      <div style={{ fontSize: '0.85rem', fontWeight: 700, color: '#16a34a' }}>{review.growth}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Video Testimonial */}
          <div className="text-center mb-4" style={{ maxWidth: '480px', margin: '0 auto' }}>
            <div style={{
              background: '#fff',
              border: '1px solid #e8ecf1',
              borderRadius: '20px',
              padding: '1rem',
            }}>
              <DeferredVideo
                src="https://i.imgur.com/fIKySBd.mp4"
                poster="https://i.imgur.com/fIKySBd.png"
                ariaLabel="Play customer testimonial"
              />
              <a href="https://instagram.com/smoke" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <div className="d-flex align-items-center gap-3 mt-3 px-1">
                  <img src="https://i.imgur.com/kFw388B.jpeg" alt="Smoke" style={{ width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #f1f5f9' }} />
                  <div className="text-start" style={{ flex: 1 }}>
                    <div className="d-flex align-items-center gap-1">
                      <span style={{ fontWeight: 600, fontSize: '0.85rem', color: '#0a2540' }}>@smoke</span>
                      <img loading="lazy" alt={L.testimonials.verifiedAlt} src="https://rizzup.net/images/check.svg" width="14" height="14" />
                    </div>
                    <div style={{ fontSize: '0.73rem', color: '#94a3b8' }}>{L.testimonials.smokeTitle}</div>
                  </div>
                  <div className="d-inline-block px-2 py-1" style={{ background: '#f0fdf4', borderRadius: '10px', fontSize: '0.7rem', fontWeight: 600, color: '#16a34a' }}>
                    <i className="fa-solid fa-arrow-trend-up" style={{ marginRight: '3px', fontSize: '0.65rem' }}></i>
                    +179k
                  </div>
                </div>
              </a>
            </div>
          </div>

          {/* Profile Row */}
          <div className="d-flex flex-wrap justify-content-center gap-3 mb-2" style={{ maxWidth: '860px', margin: '0 auto' }}>
            {profiles.map((item, i) => (
              <a key={i} href={item.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', flex: '1 1 0', minWidth: '140px', maxWidth: '200px' }}>
                <div style={{
                  background: '#fff',
                  border: '1px solid #e8ecf1',
                  borderRadius: '18px',
                  padding: '1.25rem 0.75rem',
                  textAlign: 'center',
                  transition: 'box-shadow 0.3s ease, transform 0.3s ease',
                }}
                onMouseOver={(e) => { e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                onMouseOut={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                  <img src={item.img} alt={item.name} style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #f1f5f9', display: 'block', margin: '0 auto 0.6rem' }} />
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <span style={{ fontWeight: 600, fontSize: '0.8rem', color: '#0a2540' }}>{item.name}</span>
                    {item.verified && <img loading="lazy" alt={L.testimonials.verifiedAlt} src="https://rizzup.net/images/check.svg" width="12" height="12" />}
                  </div>
                  <div style={{ fontSize: '0.7rem', color: '#94a3b8', marginTop: '1px' }}>{L.testimonials.followersCount(item.followers)}</div>
                  <div className="mt-2 d-inline-block px-2 py-1" style={{ background: '#f0fdf4', borderRadius: '10px', fontSize: '0.65rem', fontWeight: 600, color: '#16a34a' }}>
                    <i className="fa-solid fa-arrow-trend-up" style={{ marginRight: '2px', fontSize: '0.6rem' }}></i>
                    {item.growth}
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* As Featured On */}
          <div className="text-center mt-5">
            <p style={{ fontSize: '0.7rem', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#94a3b8', marginBottom: '1rem' }}>
              {L.testimonials.asFeaturedOn}
            </p>
            <div className="relative overflow-hidden" style={{ height: '50px' }}>
              <div className="tech-slideshow absolute left-0 top-0 w-full h-full">
                <div className="mover-1 flex items-center h-full">
                  {[...Array(2)].map((_, i) => (
                    <React.Fragment key={i}>
                      <span className="px-5 d-inline-flex align-items-center gap-2" style={{ opacity: 0.35, fontSize: '1.4rem', color: '#0a2540', whiteSpace: 'nowrap' }}>
                        <span aria-hidden="true">★</span> <span style={{ fontWeight: 700, fontSize: '0.95rem' }}>Trustpilot</span>
                      </span>
                      <span className="px-5 d-inline-flex align-items-center gap-2" style={{ opacity: 0.35, whiteSpace: 'nowrap' }}>
                        <span style={{ fontWeight: 900, fontSize: '1.1rem', color: '#0a2540', fontFamily: 'Georgia, "Times New Roman", serif', letterSpacing: '-0.02em' }}>Entrepreneur</span>
                      </span>
                      <span className="px-5 d-inline-flex align-items-center gap-2" style={{ opacity: 0.35, fontSize: '1.4rem', color: '#0a2540', whiteSpace: 'nowrap' }}>
                        <i className="fab fa-medium"></i> <span style={{ fontWeight: 700, fontSize: '0.95rem' }}>Medium</span>
                      </span>
                      <span className="px-5 d-inline-flex align-items-center gap-2" style={{ opacity: 0.35, fontSize: '1.4rem', color: '#0a2540', whiteSpace: 'nowrap' }}>
                        <i className="fab fa-reddit"></i> <span style={{ fontWeight: 700, fontSize: '0.95rem' }}>Reddit</span>
                      </span>
                      <span className="px-5 d-inline-flex align-items-center gap-2" style={{ opacity: 0.35, whiteSpace: 'nowrap' }}>
                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/OpenAI_Logo.svg/3840px-OpenAI_Logo.svg.png" style={{ height: '20px', filter: 'brightness(0)' }} alt="OpenAI" />
                      </span>
                      <span className="px-5 d-inline-flex align-items-center gap-2" style={{ opacity: 0.35, fontSize: '1.4rem', color: '#0a2540', whiteSpace: 'nowrap' }}>
                        <i className="fab fa-product-hunt"></i> <span style={{ fontWeight: 700, fontSize: '0.95rem' }}>Product Hunt</span>
                      </span>
                      <span className="px-5 d-inline-flex align-items-center gap-2" style={{ opacity: 0.35, fontSize: '1.4rem', color: '#0a2540', whiteSpace: 'nowrap' }}>
                        <i className="fab fa-hubspot"></i> <span style={{ fontWeight: 700, fontSize: '0.95rem' }}>HubSpot</span>
                      </span>
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          {!isRegisterPage && !hideCta && (
            <div className="text-center mt-5">
              {/* Not a bare #pricing anchor: the home page no longer renders a
                  pricing section to scroll to, so this has to name the page.
                  On /pricing the fragment resolves to the plan picker. */}
              <a
                href="/pricing#pricing"
                className="group inline-flex items-center justify-center gap-2 px-8 py-4 text-lg font-semibold text-white rounded-xl bg-instagram transition-all duration-200 hover:scale-105 text-decoration-none"
                style={{ boxShadow: '0 4px 14px 0 rgba(225, 48, 108, 0.3)' }}
              >
                {L.testimonials.ctaButton}
                <i className="fa-solid fa-arrow-right transition-transform group-hover:translate-x-1"></i>
              </a>
              <p className="mt-3" style={{ fontSize: '0.8rem', color: '#94a3b8' }}>
                {L.testimonials.ctaSub}
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Why More Followers Section */}
      <section className="stripe-section stripe-section--gradient">
        <div className="mx-auto px-4 text-center stripe-container">
          <span className="text-instagram stripe-label">{L.testimonials.whyLabel}</span>
          <h2 className="mt-3 stripe-heading stripe-heading--md">
            {L.testimonials.whyHeading}
          </h2>
          <p className="mt-2 mx-auto mb-5 stripe-body stripe-body--md" style={{ maxWidth: '460px' }}>
            {L.testimonials.whySub}
          </p>

          <div className="grid md:grid-cols-3 gap-6" style={{ maxWidth: '960px', margin: '0 auto' }}>
            {[
              { icon: 'fas fa-handshake' },
              { icon: 'fas fa-link' },
              { icon: 'fas fa-chart-line' },
            ].map((card, i) => (
              <div
                key={i}
                className="text-center"
                style={{ background: '#fff', border: '1px solid #e8ecf1', borderRadius: '20px', padding: '2rem 1.75rem' }}
              >
                <div className="d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '48px', height: '48px', borderRadius: '14px', background: 'linear-gradient(135deg, #fce7f3 0%, #f0ebff 100%)' }}>
                  <i className={`${card.icon} text-instagram`} style={{ fontSize: '1.1rem' }}></i>
                </div>
                <h3 className="stripe-heading stripe-heading--xs" style={{ marginBottom: '0.5rem' }}>{L.testimonials.whyCards[i].title}</h3>
                <p className="mb-0 stripe-body stripe-body--sm">{L.testimonials.whyCards[i].desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonials;
